var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"login-btn w-100",on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('span',{staticClass:"btn-name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }